class TrHeader extends HTMLElement {
	selectors = {
		menuToggle: '[data-tr-js-menu-toggle]',
		menuDrawer: '[data-tr-js-menu-drawer]',
		menuLinks: '[data-tr-js-menu-link]'
	};

	attributes = {
		ariaExpanded: 'aria-expanded',
		ariaHidden: 'aria-hidden'
	};

	stateClasses = {
		isOpen: 'is-open',
		bodyScrollLocked: 'tr-scroll-locked'
	};

	connectedCallback() {
		this.documentElement = document.documentElement;
		this.menuToggleElement = this.querySelector(this.selectors.menuToggle);
		this.menuDrawerElement = this.querySelector(this.selectors.menuDrawer);
		this.menuLinkElements = this.querySelectorAll(this.selectors.menuLinks);

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.closeMenu();
		this.setHeaderHeight();
	}

	bindEvents() {
		this.menuToggleElement?.addEventListener('click', this.onMenuToggleClick);
		this.menuLinkElements.forEach(menuLinkElement => {
			menuLinkElement.addEventListener('click', this.closeMenu);
		});
		document.addEventListener('shopify:section:load', this.onSectionLoad);
		this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
		this.resizeObserver.observe(this);
	}

	onMenuToggleClick = () => {
		if (this.menuToggleElement?.classList.contains(this.stateClasses.isOpen)) {
			this.closeMenu();
			return;
		}

		this.openMenu();
	};

	onSectionLoad = event => {
		if (!this.closest(`#${event.detail.sectionId}`)) return;

		this.init();
	};

	setHeaderHeight = () => {
		const headerRectangle = this.getBoundingClientRect();
		const headerHeight = Math.max(
			0,
			Math.round(headerRectangle.bottom + window.scrollY)
		);
		const rootFontSize = Number.parseFloat(
			window.getComputedStyle(this.documentElement).fontSize
		);
		const headerHeightInRem = headerHeight / rootFontSize;

		this.documentElement.style.setProperty(
			'--tr-header-height',
			`${headerHeightInRem}rem`
		);
	};

	openMenu() {
		this.menuToggleElement?.classList.add(this.stateClasses.isOpen);
		this.menuToggleElement?.setAttribute(this.attributes.ariaExpanded, 'true');
		this.menuDrawerElement?.classList.add(this.stateClasses.isOpen);
		this.menuDrawerElement?.setAttribute(this.attributes.ariaHidden, 'false');
		document.body.classList.add(this.stateClasses.bodyScrollLocked);
	}

	closeMenu = () => {
		this.menuToggleElement?.classList.remove(this.stateClasses.isOpen);
		this.menuToggleElement?.setAttribute(this.attributes.ariaExpanded, 'false');
		this.menuDrawerElement?.classList.remove(this.stateClasses.isOpen);
		this.menuDrawerElement?.setAttribute(this.attributes.ariaHidden, 'true');
		document.body.classList.remove(this.stateClasses.bodyScrollLocked);
	};

	destroy() {
		this.menuToggleElement?.removeEventListener(
			'click',
			this.onMenuToggleClick
		);
		this.menuLinkElements.forEach(menuLinkElement => {
			menuLinkElement.removeEventListener('click', this.closeMenu);
		});
		document.removeEventListener('keydown', this.onDocumentKeydown);
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		this.resizeObserver?.disconnect();
		this.closeMenu();
	}
}

if (!customElements.get('tr-header')) {
	customElements.define('tr-header', TrHeader);
}
